<template>
  <div>
    <section id="over-rijnja" class="content-wrapper page">
      <section id="" class="row header">
        <div class="col text">
          <h1>Leveringsvoorwaarden</h1>
          <a
            href="/docs/Leveringsvoorwaarden Koninklijke Rijnja BV.pdf"
            download="Leveringsvoorwaarden Koninklijke Rijnja BV - 22 mei 2018.pdf"
            target="_blank"
            class="main-button dl-btn"
            >Downloaden</a
          >
          <p>
            Leveringsvoorwaarden van Koninklijke Rijnja B.V., vastgesteld op 22
            mei 2018.
          </p>
          <ol>
            <li>
              <p>
                Alle offertes zijn vrijblijvend en gelden voor ten hoogste één
                maand, tenzij uitdrukkelijk anders is overeengekomen. Alle
                opgegeven prijzen zijn exclusief omzetbelasting en andere door
                de overheid opgelegde heffingen.
              </p>
              <p>
                Bij samengestelde prijsopgaven bestaat geen verplichting tot
                levering van een gedeelte tegen een overeenkomstig gedeelte van
                de voor het geheel opgegeven prijs. Vrachten en porti zijn voor
                rekening van de opdrachtgever.
              </p>
            </li>

            <li>
              <p>
                Wijzigingen in de gebruikelijke of oorspronkelijk overeengekomen
                wijze van aanlevering van originelen en-of bestanden,
                ondeugdelijke instructies, originelen of bestanden en-of door de
                opdrachtgever bijgeleverde materialen of producten, alsmede
                onvoorziene verwerkingsproblemen en extra werkzaamheden zijn
                grond voor verhoging van de overeengekomen prijs en kunnen tot
                uitstel van levering leiden.
              </p>
              <p>
                Tevens kan de leverancier niet aansprakelijk worden gesteld voor
                de gevolgen van dergelijke wijzigingen, ondeugdelijke
                instructies, originelen of bestanden en-of door de opdrachtgever
                bijgeleverde materialen of producten.
              </p>
            </li>

            <li>
              <p>
                Door het geven van een opdracht tot verveelvoudiging of
                reproductie of gebruik van een door de Auteurswet of enig
                eigendomsrecht beschermde zaak verklaart de opdrachtgever dat
                geen inbreuk op het auteursrecht of enig ander recht van derden
                wordt gemaakt en vrijwaart hij de leverancier in en buiten
                rechte voor alle gevolgen, zowel financiële als andere, uit de
                verveelvoudiging of reproductie of het gebruik voortvloeiende.
              </p>
              <p>
                Ook in het geval dat uit de verveelvoudiging of reproductie of
                het gebruik financiële verplichtingen tegenover de auteur of
                rechthebbende of diens rechtverkrijgenden voortvloeien, komen
                deze voor rekening van de opdrachtgever.
              </p>
            </li>
            <li>
              <p>
                Indien ter uitvoering van de opdracht door de opdrachtgever data
                en/of databestanden aan de leverancier ter beschikking worden
                gesteld bevattende persoonsgegevens als bedoeld in de Algemene
                Verordening Gegevensbescherming (AVG) en/of daarop aansluitende
                uitvoeringswetgeving of regelgeving, dan staat opdrachtgever
                ervoor in dat de persoonsgegevens rechtmatig door opdrachtgever
                zijn verzameld, verwerkt respectievelijk zijn geregistreerd.
              </p>
              <p>
                Opdrachtgever garandeert leverancier voorts dat hij zich
                volledig houdt aan alle verplichtingen die uit hoofde van de AVG
                (en/of daarop aansluitende uitvoeringswetgeving of regelgeving)
                op hem rusten. Opdrachtgever vrijwaart de leverancier voor alle
                schade, aanspraken en/of claims die uit hoofde van de verwerking
                van bedoelde (data)bestanden en persoonsgegevens voortvloeien,
                daaronder mede begrepen alle juridische kosten die de
                leverancier in het kader van een geschil dienaangaande heeft
                moeten maken.
              </p>
            </li>
            <li>
              <p>
                Annulering van een opdracht is mogelijk, mits de opdrachtgever
                de leverancier schadeloos stelt voor alle reeds gemaakte kosten
                alsmede 10 procent van de opdrachtsom.
              </p>
            </li>
            <li>
              <p>
                De opdrachtgever draagt het risico voor alle door hem aan de
                leverancier voor de uitvoering van de opdracht ter beschikking
                gestelde zaken.
              </p>
            </li>
            <li>
              <p>
                Aansprakelijkheid van de leverancier voor vervolgschade is
                volledig uitgesloten. De aansprakelijkheid van de leverancier
                voor schade is te allen tijde beperkt tot het bedrag van ten
                hoogste het bedrag van de met het werk of het geleverde
                corresponderende factuur.
              </p>
            </li>
            <li>
              <p>
                De met de leverancier overeengekomen leveringstermijnen zijn
                door de opdrachtgever steeds als approximatief en nimmer als
                fatale termijnen aan te merken, tenzij het tegendeel
                uitdrukkelijk schriftelijk is overeengekomen.
              </p>
            </li>
            <li>
              <p>
                De afgifte van de door de opdrachtgever ter beschikking gestelde
                zaken en het door de leverancier gemaakte werk geschiedt
                desgewenst tegen teruggave van een door de leverancier verstrekt
                ontvangstbewijs. Of de aanbieder hiervan tot inontvangstname
                gerechtigd is, valt buiten de beoordeling en
                verantwoordelijkheid van de leverancier.
              </p>
            </li>
            <li>
              <p>
                Tenzij anders is overeengekomen, geschiedt de aflevering ter
                plaatse waar de leverancier zijn bedrijf uitoefent. De
                opdrachtgever is gehouden zijn volledige medewerking te verlenen
                aan de aflevering van de door de leverancier te leveren zaken.
              </p>
            </li>
            <li>
              <p>
                Indien de door de opdrachtgever ter beschikking gestelde zaken
                en/of het door de leverancier gemaakte werk niet op de
                overeengekomen datum worden afgehaald, bewaart de leverancier
                deze zes weken, te rekenen vanaf de datum van bestelling,
                onverminderd de verschuldigdheid van betaling door de
                opdrachtgever. Voor schade aan deze zaken welke als gevolg van
                het bewaren mocht ontstaan, is de leverancier niet
                aansprakelijk.
              </p>
            </li>
            <li>
              <p>
                Bij franco levering wordt steeds de goedkoopste wijze van
                verzending gevolgd, tenzij tevoren anders is overeengekomen.
              </p>
            </li>
            <li>
              <p>
                Alle door de leverancier vervaardigde zaken zoals ontwerpen,
                modellen, foto's en films, montages, tussenoriginelen,
                bestanden, computerprogramma's en proeven die niet tot het
                uiteindelijk te leveren product of de uit te voeren dienst
                behoren, blijven het eigendom van de leverancier, ook als deze
                als aparte post zijn geoffreerd of gefactureerd. De leverancier
                is niet gehouden de hiervoor genoemde zaken na voltooiing van de
                opdracht te bewaren.
              </p>
            </li>
            <li>
              <p>
                Bij maatvast werk wordt de juiste instelling gegarandeerd.
                Maatverschillen als gevolg van krimpen of rekken van de te
                gebruiken materialen zijn evenwel niet steeds te vermijden en
                kunnen geen reden voor afkeuring zijn.
              </p>
              <p>
                Afwijkingen tussen enerzijds het geleverde werk en anderzijds
                het origineel en/of de gegegeven instructies kunnen geen reden
                van afkeuring zijn indien in redelijkheid kan worden gesteld dat
                zij, de omstandigheden in aanmerking genomen, geen invloed
                hebben op de gebruikswaarde van het werk.
              </p>
            </li>
            <li>
              <p>
                Meer- of minderleveringen ten opzichte van het overeengekomen
                aantal zijn toegestaan indien zij niet meer of minder zijn dan
                de volgende percentages:
              </p>
              <p>
                - oplage tot 2.000 eenheden: 5 procent - oplage van 2.000 en
                meer: 2,5 procent
              </p>
              <p>
                Het meer of het minder geleverde aantal wordt tegen stuksprijs
                in rekening gebracht respectievelijk verrekend.
              </p>
            </li>
            <li>
              <p>
                Eventuele reclames inzake de geleverde goederen of de in
                rekening gebrachte prijs, moeten binnen acht dagen na ontvangst
                van de goederen respectievelijk van de factuur schriftelijk ter
                kennis van de leverancier zijn gebracht. Indien binnen acht
                dagen zulke reclames niet door de leverancier zijn ontvangen,
                wordt de opdrachtgever geacht met de geleverde goederen en de
                gefactureerde prijs te hebben ingestemd.
              </p>
            </li>
            <li>
              <p>
                De leverancier is steeds gerechtigd een nieuwe deugdelijke
                prestatie in de plaats van een eerdere ondeugdelijke prestatie
                te stellen, tenzij het verzuim niet herstelbaar is.
              </p>
              <p>
                De prestatie van de leverancier geldt in elk geval tussen
                partijen als deugdelijk, indien de opdrachtgever het geleverde
                of een gedeelte van het geleverde in gebruik heeft genomen,
                heeft bewerkt of verwerkt, aan derden heeft geleverd,
                respectievelijk in gebruik heeft doen nemen, heeft doen bewerken
                of verwerken of aan derden heeft doen leveren.
              </p>
            </li>
            <li>
              <p>
                Wanneer opdrachten worden verstrekt voor rekening van derden,
                kan de opdrachtgever geen aanspraak maken op kosteloze
                afzonderlijke of gesplitste facturering aan deze derden.
              </p>
            </li>
            <li>
              <p>
                Wanneer een opdracht aan de leverancier wordt verstrekt ten
                behoeve en voor rekening van een derde, blijft de feitelijke
                opdrachtgever voor de voldoening van de factuur, naast de derde,
                hoofdelijk voor het geheel aansprakelijk.
              </p>
            </li>
            <li>
              <p>
                Betaling dient, tenzij tevoren anders is overeengekomen, zonder
                aftrek van korting of recht van verrekening binnen 14 dagen na
                factuurdatum te geschieden. Bij latere betaling, ook indien de
                leverancier daarmede heeft ingestemd, is de opdrachtgever voor
                elke maand of gedeelte daarvan de wettelijke rente van het
                factuurbedrag verschuldigd.
              </p>
              <p>
                De leverancier heeft het recht contante betaling of extra
                zekerheden te verlangen. Bij niet tijdige betaling is de
                opdrachtgever in verzuim zonder dat ingebrekestelling door de
                leverancier is vereist.
              </p>
            </li>
            <li>
              <p>
                Alle kosten, zowel gerechtelijke als buitengerechtelijke,
                gemaakt met betrekking tot de invordering van het door de
                opdrachtgever verschuldigde en niet tijdig betaalde, zijn voor
                rekening van de opdrachtgever; zij worden op minimaal 15 procent
                van het betrokken bedrag gefixeerd en zullen ten minste € 50
                bedragen.
              </p>
            </li>
            <li>
              <p>
                De opdrachtgever verleent de leverancier pandrecht op alle zaken
                die in het kader van de nakoming van de overeenkomst met de
                leverancier door hem in de macht van de leverancier worden
                gebracht, zulks tot meerdere zekerheid van al hetgeen de
                opdrachtgever in welke hoedanigheid en uit welke hoofde ook aan
                de leverancier verschuldigd mocht zijn, niet opeisbare en
                voorwaardelijke schulden daaronder mede begrepen.
              </p>
            </li>
            <li>
              <p>
                Iedere levering van werk door de leverancier aan de
                opdrachtgever geschiedt onder voorbehoud van eigendom daarvan
                tot de opdrachtgever alles heeft voldaan waartoe hij uit hoofde
                van de overeenkomst is gehouden, daaronder begrepen betaling van
                rente en kosten.
              </p>
            </li>
            <li>
              <p>
                Storingen in het bedrijf ten gevolge van overmacht, als hoedanig
                o.a. zullen gelden: oorlog, mobilisatie, onlusten, overstroming,
                stremmingen in het vervoer, stagnatie in of stopzetten van
                leveringen door openbare nutsbedrijven en leveranciers van
                elektriciteit en brandstoffen, brand, machinebreuk en andere
                ongevallen, arbeidsconflicten waardoor produceren onmogelijk
                wordt, maatregelen van overheidswege, niet levering van
                noodzakelijke materialen en halffabrikaten aan leverancier door
                derden en andere onvoorziene omstandigheden, ook in het land van
                herkomst van materialen en halffabrikaten, welke de normale
                bedrijfsgang storen en de uitvoering van een order vertragen of
                redelijkerwijs onmogelijk maken, ontslaan de leverancier van het
                nakomen van de overeengekomen leveringstermijn of van zijn
                leveringsplicht, zonder dat de opdrachtgever uit dien hoofde
                enig recht op vergoeding van kosten, schade en interesten kan
                doen gelden.
              </p>
              <p>
                Bij stijging van de prijzen van materialen en halffabrikaten die
                voor de uitvoering van de order nodig zijn, verandering van
                lonen, ernstige wijzigingen in de valutaverhoudingen en
                dergelijke omstandigheden, zich voordoende na aanvaarding van
                een order, is de leverancier gerechtigd de overeengekomen
                prijzen dienovereenkomstig te verhogen.
              </p>
            </li>
            <li>
              <p>
                Door het geven van een order erkent de opdrachtgever deze
                leveringsvoorwaarden te kennen en er genoegen mede te nemen,
                indien zij hem althans tevoren waren medegedeeld of indien er
                bij de offerte en/of orderbevestiging naar werd verwezen, dan
                wel indien zij in het bedrijf van leverancier op een voor
                opdrachtgevers duidelijk zichtbare plaats zijn opgehangen.
                Wanneer in een bevestiging van de opdrachtgever bepalingen of
                voorwaarden voorkomen welke in strijd zijn met deze
                leveringsvoorwaarden, kunnen deze niet worden erkend. De
                opdrachtgever kan zich hierbij niet beroepen op het zogenoemde
                gewoonterecht.
              </p>
              <p>
                Bij samentreffen van door de opdrachtgever gebezigde uniforme
                inkoopvoorwaarden en de onderhavige leveringsvoorwaarden zullen
                de laatste prevaleren.
              </p>
            </li>
            <li>
              <p>
                Op overeenkomsten tussen de leverancier en de opdrachtgever is
                het Nederlandse recht van toepassing.
              </p>
              <p>
                Op alle offertes en overeenkomsten is uitsluitend Nederlands
                recht van toepassing. Alle geschillen verband houdende met of
                voortvloeiende uit de door leverancier gedane offertes en/of de
                tussen partijen tot stand gekomen overeenkomst(en), zullen
                uitsluitend worden voorgelegd aan de bevoegde rechter in de
                woonplaats van leverancier, dan wel - ter keuze van de
                leverancier - de bevoegde rechter in de woonplaats van de
                opdrachtgever.
              </p>
            </li>
            <li>
              <p>
                Koninklijke Rijnja B.V.<br />
                Ravenswade 2B<br />
                3439 LD Nieuwegein
              </p>
            </li>
          </ol>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import SiteFooter from '../../components/SiteFooter.vue'
export default {
  components: {
    SiteFooter
  },
  methods: {
    goHome() {
      this.rootStore.setHome()
    }
  },
  mounted() {
    this.rootStore.setFullscreen(true)
  },
  beforeUnmount() {
    this.rootStore.setFullscreen(false)
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

ol,
ul {
  list-style: none;
}

.dl-btn {
  width: 100px;
  text-align: center;
}

.text-row {
  position: relative;

  .close-button {
    right: -15px;
    top: -5px;
    z-index: 10;
  }
}
</style>
